import React, { useState, useEffect } from 'react';
import {
    InfoContainer,
    CardContainer,
    Select,
    Form,
    FormInput,
    FilterWrap,
    NextButton,
    AssetOverlay,
    HeadingHelpersContainer,
    PlayerOptionContainer,
    VStack,
    PlayerHeadingHelper,
    PlayerNavHelper,
    FormH4
} from './PlayerDisplayElements'
import PlayerCard from './PlayerCard';
import GetAssets from '../CrewBuilderForms/GetAssets';

const PlayerOptionList = ({ isOpen, handleAdd, currentTeamCost, listStatus, playersList, fillPosition, handleClose, captainMode = true }) => {

    // const [playersList, setPlayersList] = useState([]);
    // const [listStatus, setListStatus] = useState(false);
    // const [search, setSearch] = useState('');
    // const [updatePlayers, setUpdatePlayers] = useState([]);
    const [doubleFilter, setDoubleFilter] = useState([]);
    const [start, setStart] = useState(0);
    const [finish, setFinish] = useState(9);
    const [initialColor, setInitialColor] = useState('whitesmoke') // Set to red if you require a selection

    const handleChange = e => {
        const nameList = playersList.assets.filter(player => player.name.toLowerCase().includes(e.target.value.toLowerCase()))
        const posList = playersList.assets.filter(player => player.position.toLowerCase().includes(e.target.value.toLowerCase()))
        const teamList = playersList.assets.filter(player => player.team.toLowerCase().includes(e.target.value.toLowerCase()))
        const newList = [...nameList, ...posList, ...teamList];
        const updatedList = e.target.value === "" ? (playersList.assets) : ([...new Set(newList)])
        setDoubleFilter(updatedList.sort((a, b) => a.currentSalary < b.currentSalary ? 1 : -1));
        setStart(0);
        setFinish(9);
    };

    const handleCategoryChange = e => {
        setInitialColor('whitesmoke')
        if (e.target.value === "") {
            setDoubleFilter(playersList.assets.sort((a, b) => a.currentSalary < b.currentSalary ? 1 : -1))
            setStart(0);
            setFinish(9);
        }
        else {
            setDoubleFilter(playersList.assets.filter(player => player.position === e.target.value).sort((a, b) => a.currentSalary < b.currentSalary ? 1 : -1))
            setStart(0);
            setFinish(9);
        }
    }

    const handleClick = e => {
        const length = doubleFilter.length
        if (finish > length) {
            setStart(0);
            setFinish(9);
        }
        else {
            setStart(start + 9);
            setFinish(finish + 9);
        }
    }

    const handlePrevious = e => {
        if (start >= 9) {
            setStart(start - 9);
            setFinish(finish - 9);
        }
    }

    useEffect(() => {
        console.log(fillPosition)
        if (fillPosition === "") {
            setDoubleFilter(playersList.assets.sort((a, b) => a.currentSalary < b.currentSalary ? 1 : -1))
            setStart(0);
            setFinish(9);
        }
        else {
            setDoubleFilter(playersList.assets.filter(player => player.position === fillPosition).sort((a, b) => a.currentSalary < b.currentSalary ? 1 : -1))
            setStart(0);
            setFinish(9);
        }
    }, [])

    // useEffect(() => {
    //     const playersWait = async () => {
    //         const playersInWait = await GetAssets().then(assets => assets)
    //         setPlayersList(JSON.parse(playersInWait));
    //         setListStatus(true);
    //     }
    //     playersWait()
    //         .catch(console.error());;
    // }, []);

    if (!isOpen) return null;
    return (
        <div>
            {listStatus ? (
                <AssetOverlay>
                    <PlayerOptionContainer lightBg={false} >
                        <FilterWrap>
                            <FormH4 style={{ fontSize: '14px', margin: '12px' }}>Remaining: {50000 - currentTeamCost}</FormH4>
                            <PlayerHeadingHelper swap={false}>
                                <Form>
                                    <FormInput
                                        className='filter-input'
                                        type='text'
                                        onChange={handleChange}
                                        placeholder='Search'
                                    />
                                </Form>
                                <Select style={{ outline: `2px solid ${initialColor}` }} onChange={handleCategoryChange}>
                                    <option value="" hidden>
                                        Position (All)
                                    </option>
                                    {captainMode ? (
                                        <>
                                            <option value="CPT">Captain</option>
                                            <option value="FLEX">Flex</option>
                                        </>) :
                                        <>
                                            <option value="QB">Quarterback</option>
                                            <option value="RB">Running Back</option>
                                            <option value="WR">Wide Receiver</option>
                                            <option value="TE">Tight End</option>
                                            <option value="DST">Defense</option>
                                        </>}
                                </Select>
                            </PlayerHeadingHelper>
                            <PlayerNavHelper>
                                <NextButton style={{ marginLeft: '0PX' }} onClick={handlePrevious} dark={true}> Previous </NextButton>
                                <NextButton style={{ marginLeft: '0PX' }} onClick={handleClick} dark={true}>  Next </NextButton>
                            </PlayerNavHelper>
                        </FilterWrap>
                        <CardContainer>
                            {
                                doubleFilter.slice(start, finish).map((p, ind) => (
                                    <PlayerCard player={p} handleAdd={handleAdd} teamCost={currentTeamCost} />
                                ))}
                        </CardContainer>
                        <NextButton style={{ justifySelf: 'center', color: 'red', marginBottom: '12px' }} onClick={handleClose} dark={true}>  Close </NextButton>
                    </PlayerOptionContainer>
                </AssetOverlay>
            ) :
                <AssetOverlay></AssetOverlay>

            }
        </div>
    )
};

export default PlayerOptionList;